<template>
  <div class="calculadora calculadora-gravidez">
    <div class="row">
        <div class="col-md-4 mb-4">
            <div class="gra-instrucoes">
              {{ strings.instructions.desc }}
            </div>
        </div>
        <form @submit.prevent="calculate()" class="col-md-4">
            <h3 class="gra-titulo">{{ strings.fields.title }}</h3>
            <div class="form-group">
                <input id="fld-gra-dataMenstruacao" class="form-control" v-model="dataMenstruacao" type="date" placeholder="Digite aqui a data" />
                <label for="fld-gra-dataMenstruacao">{{ strings.fields.select_label }}</label>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary">{{ strings.calulate }}</button>
            </div>
        </form>
        <div class="col-md-4">
            <div v-if="showResults">
                <div>
                    <div class="gra-titulo">{{ strings.results.title }}</div>

                    <div class="gra-resultado">
                        <strong>{{gravidezSemanas}}</strong>
                        <span> {{ strings.results.gap01 }} </span>
                        <strong>{{gravidezDias}}</strong>
                        <span> {{ strings.results.gap02 }}</span>

                        <div class="gra-detail">
                            <span>{{ strings.results.info }}</span>
                        </div>
                    </div>

                    <div class="gra-explicacao">
                        <small>{{ strings.results.disclaimer }}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    import { DateTime } from 'luxon';

    export default {

        props: {
            strings: Object
        },

        data: () => { return {
            dataMenstruacao: null,
            showResults: false,
        }},

        computed: {
            gravidezDuracao: function() {
                if (!this.dataMenstruacao) {
                    return null;
                }

                let menstruacao = DateTime.fromISO(this.dataMenstruacao);
                let hoje = DateTime.local();

                return hoje.diff(menstruacao);
            },
            gravidezSemanas: function() {
                if (!this.gravidezDuracao) {
                    return 0;
                }

                return Math.floor(this.gravidezDuracao.as('weeks'));
            },

            gravidezDias: function() {
                if (!this.gravidezDuracao) {
                    return 0;
                }

                let daysInWeeks = this.gravidezSemanas * 7;

                return Math.ceil(this.gravidezDuracao.as('days')) - daysInWeeks;
            },
        },

        methods: {
            calculate: function() {
                this.showResults = true;
            }
        }
    }
</script>
